<div class="user-info">

  <div class="info">
    <div>
      <div class="name">Hi, {{user?.full_name?.split(' ')[0]}}</div>
      <div class="email">{{user?.email}}</div>
    </div>
    <button (click)="onClickEdit()" mat-icon-button>
      <mat-icon class="edit-icon">edit</mat-icon>
    </button>
  </div>
  <mat-checkbox class="anonymous-check" [(ngModel)]="isAnonymous" color="primary">
    {{'Stories.donations.donationAnonymous' | translatePipe | async}}
  </mat-checkbox>
  <div class="text-center proceed-btn">
    <app-donate-btn id="formSubmit" class="app-button" [btnClass]="'contri-initiate-btn donation-form-submit'" type="submit"
                    [label]="config.donate_label | translatePipe | async" [isOrderLoading]="isLoading" [amount]="amount"
                    [type]="paymentUtilService.paymentMode" [isSipCause]="isSipCause" (onClickListner)="onSubmit()">
    </app-donate-btn>
  </div>
</div>